(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const hiddenProducts = [
      'custom-air-filters-triple-1/2',
      'custom-air-filters-double-1/2',
      'custom-air-filters-single-1/2'
    ];

    function hideCustomFilters() {
      document.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
        const href = link.getAttribute('href') || '';

        const productHandle = href
          .split('/products/')[1]
          ?.split('?')[0]
          ?.split('#')[0];

        if (hiddenProducts.includes(productHandle)) {
          const productCard = link.closest(
            'product-card, .product-card, .card, li, .grid__item'
          );

          if (productCard) {
            productCard.style.display = 'none';
          }
        }
      });
    }

    hideCustomFilters();

    const observer = new MutationObserver(hideCustomFilters);

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
  } catch(e) { console.error(e); }
})();

})();
